<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="modalTitle" :modal-id="idModal" @close="back">
            <template v-slot:modal-body>
                <div class="p-x-4 f-regular f-c-black f-16">
                    <p>
                        Yakin ingin menghapus mesin <span class="text-promo">{{ detailMesin.nama_mesin_edc }}</span
                        >? Data keuangan akan tetap tersimpan, namun data mesin tidak dapat dikembalikan.
                    </p>
                    <input type="checkbox" :id="`${idModal}-check`" v-model="isDisabled" class="m-r-4" />
                    <label :for="`${idModal}-check`">Ya, saya yakin ingin menghapus mesin ini.</label>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :outlineDanger="true"
                        :text="`Hapus mesin ini`"
                        :full="true"
                        :id="`btn-delete-mesin`"
                        :disable="!isDisabled"
                        :loading="isFetching"
                        @action="doDelete"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../store/state";

export default {
    name: "ModalDeleteConfirm",
    components: {
        SOSlotModal,
        SOButton,
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    data() {
        return {
            idModal: `modal-delete-confirm`,
            isDisabled: false,
        };
    },
    mounted() {
        $(`#${this.idModal}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            detailMesin: "detailMesin",
            isFetching: "isFetching",
        }),
        modalTitle() {
            return "Hapus Mesin EDC";
        },
    },
    methods: {
        ...mapActions({
            deleteMesinEdc: `${moduleName}/deleteMesinEdc`,
            resetListMesin: `${moduleName}/resetListMesin`,
            resetPagination: `${moduleName}/resetPagination`,
            setFetching: `${moduleName}/setFetching`,
        }),
        back() {
            this.$router.push({ name: "mesin.edc.detail" });
        },
        closeModal() {
            $(`#${this.idModal}`).modal("hide");
        },
        gotoList() {
            this.$router.push({ name: "mesin.edc.list" });
        },
        doDelete() {
            let deleting = this.deleteMesinEdc(this.detailMesin.idmesin_edc);
            deleting
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            this.$toast.success(msg);
                            this.resetListMesin();
                            this.resetPagination();
                            this.gotoList();
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
